import { Component, input, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-shared-input',
  templateUrl: './shared-input.component.html',
  styleUrl: './shared-input.component.scss'
})
export class SharedInputComponent {
  @Input() label!: string; // Input label (e.g., "First Name")
  @Input() control!: FormControl; // FormControl for the input field
  @Input() placeholder: string = ''; // Optional placeholder
  @Input() type: string = 'text'; // Input type (text, password, number, etc.)
  @Input() maxLength?: number; // Max length for the input
  @Input() dataAutoId?: string; // For test automation
  @Input() cardBrandImage?: string;
  @Input() isShowHide?: boolean = false;
  @Input() highlightOnError?: boolean = false;
  @Input() isEmailInput?: boolean = false;
  show = true;

  get showError(): boolean {
    return  this.control && this.control.touched && this.control.invalid;
  }

  toggleVisibility() {
    this.show = !this.show;
    this.show ? this.type = 'text' : this.type = 'password';
  }
}
